angular.module('cian.geoService')
  .factory('GeoApi', ["$http", function ($http) {
    var service = {};
    /*
     /ajax/jk/search-autocomplete/?r=2&searchType=3&q=мол

     параметр searchType - что ищем
     2- вернуть только ЖК
     3- вернуть ЖК и застройщиков

     параметр r - регион в котором ищем
     1- Мкс+МО
     2-Спб+ЛО
     другое значение - locationId области\края\республики
     q - поисковая строка
     */
    service.newBuildingSuggest = function (query, region_id) {
      return $http({
        method: 'GET',
        url: '/ajax/jk/search-autocomplete/',
        params: {
          r: region_id,
          q: query,
          searchType: 2
        }
      });
    };

    /**
     * @memberOf GeoApi
     * @param {string} query
     * @param {number} regionId
     * @return {*}
     */
    service.BCSuggest = function(query, regionId) {
      return $http({
        method: 'GET',
        url: '/cian-api/site/v1/bs-centers/suggest/',
        params: {
          q: query,
          region: regionId,
        }
      });
    };

    // https://conf.cian.tech/pages/viewpage.action?pageId=24478002
    service.geocode = function (data) {
      return $http({
        method: 'POST',
        url: '/api/geo/geocoded-for-search/',
        data: $.param(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      });
    };

    // https://conf.cian.tech/pages/viewpage.action?pageId=24477869
    service.geocodeCached = function (str) {
      return $http({
        method: 'GET',
        url: '/api/geo/geocode-cached/',
        params: {
          request: str
        }
      })
    };

    return service;
  }]);



// WEBPACK FOOTER //
// ./src/components/geo-service/src/scripts/cian.geoApi.js